import { z } from 'zod';

import { defineFcm } from '../shared/factory';

export const FCM_SAP_AI_EDITING_EXPERIMENT = defineFcm('sap_ai_editing_experiment')
	.asJson(
		z.object({
			experimentName: z.string().optional(),
		}),
	)
	.withDefault({ experimentName: undefined })
	.toConfig({
		owner: 'squad-starfish',
		scope: 'corgi-front-end',
		// Locale-scoped so the experiment can run per locale; unset locales fall to the default (off).
		supportedGroups: { locales: true },
		context: 'Start a Petition (SAP) AI editing step experiment',
		description:
			'Gates the sap_ai_editing_experiment step experiment on the Start a Petition flow, which adds freeform AI editing. Set `experimentName` to the Experiment Service experiment to run; it must use the variations control, fake_control and variant_a. Turn it on per locale; unset locales stay off.',
		template: { experimentName: '' },
	});
